export default {
  paymentMethods: null,
  selectedMethod: '',
}
